import { Moment } from 'moment';

export class NetzzuordnungFilter {
    constructor(
        public stadtwerkeId?: string,
        public ortsname?: string,
        public stationsname?: string,
        public trafoFeldName?: string,
        public uuid?: string,
        public uuidDateStart?: Moment,
        public uuidDateEnd?: Moment,
        public technischerPlatz?: string,
        public netzbetreiberName?: string,
        public netzbetreiberTeilgebiet?: string,
        public netzgruppe?: string,
    ) {
    }
}

